const IconCustomized = () => (
  <svg
    width="31px"
    height="29px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.817.645a1.65 1.65 0 0 0 0 3.3h19.276a1.65 1.65 0 1 0 0-3.3H1.817ZM1.817 8.027a1.65 1.65 0 0 0 0 3.3h5.968a1.65 1.65 0 0 0 0-3.3H1.817ZM1.817 15.41a1.65 1.65 0 0 0 0 3.3h3.319a1.65 1.65 0 1 0 0-3.3H1.817ZM1.817 22.791a1.65 1.65 0 1 0 0 3.3h7.037a1.65 1.65 0 1 0 0-3.3H1.817Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.35 25.223c1.7 0 3.283-.49 4.618-1.338l5.406 5.406a1.5 1.5 0 1 0 2.122-2.121l-5.308-5.308a8.636 8.636 0 1 0-6.837 3.36Zm0-3.3a5.336 5.336 0 1 0 0-10.672 5.336 5.336 0 0 0 0 10.671Z"
      fill="#fff"
    />
  </svg>
);

export default IconCustomized;
